// duel palette
const PALETTE = ['#000000','#222323','#434549','#626871','#828b98','#a6aeba','#cdd2da','#f5f7fa','#625d54','#857565','#9e8c79','#aea189','#bbafa4','#ccc3b1','#eadbc9','#fff3d6','#583126','#733d3b','#885041','#9a624c','#ad6e51','#d58d6b','#fbaa84','#ffce7f','#002735','#003850','#004d5e','#0b667f','#006f89','#328ca7','#24aed6','#88d6ff','#662b29','#94363a','#b64d46','#cd5e46','#e37840','#f99b4e','#ffbc4e','#ffe949','#282b4a','#3a4568','#615f84','#7a7799','#8690b2','#96b2d9','#c7d6ff','#c6ecff','#002219','#003221','#174a1b','#225918','#2f690c','#518822','#7da42d','#a6cc34','#181f2f','#23324d','#25466b','#366b8a','#318eb8','#41b2e3','#52d2ff','#74f5fd','#1a332c','#2f3f38','#385140','#325c40','#417455','#498960','#55b67d','#91daa1','#5e0711','#82211d','#b63c35','#e45c5f','#ff7676','#ff9ba8','#ffbbc7','#ffdbff','#2d3136','#48474d','#5b5c69','#73737f','#848795','#abaebe','#bac7db','#ebf0f6','#3b303c','#5a3c45','#8a5258','#ae6b60','#c7826c','#d89f75','#ecc581','#fffaab','#31222a','#4a353c','#5e4646','#725a51','#7e6c54','#9e8a6e','#c0a588','#ddbf9a','#2e1026','#49283d','#663659','#975475','#b96d91','#c178aa','#db99bf','#f8c6da','#002e49','#004051','#005162','#006b6d','#008279','#00a087','#00bfa3','#00deda','#453125','#614a3c','#7e6144','#997951','#b29062','#cca96e','#e8cb82','#fbeaa3','#5f0926','#6e2434','#904647','#a76057','#bd7d64','#ce9770','#edb67c','#edd493','#323558','#4a5280','#64659d','#7877c1','#8e8ce2','#9c9bef','#b8aeff','#dcd4ff','#431729','#712b3b','#9f3b52','#d94a69','#f85d80','#ff7daf','#ffa6c5','#ffcdff','#49251c','#633432','#7c4b47','#98595a','#ac6f6e','#c17e7a','#d28d7a','#e59a7c','#202900','#2f4f08','#495d00','#617308','#7c831e','#969a26','#b4aa33','#d0cc32','#622a00','#753b09','#854f12','#9e6520','#ba882e','#d1aa39','#e8d24b','#fff64f','#26233d','#3b3855','#56506f','#75686e','#917a7b','#b39783','#cfaf8e','#fedfb1','#1d2c43','#2e3d47','#394d3c','#4c5f33','#58712c','#6b842d','#789e24','#7fbd39','#372423','#53393a','#784c49','#945d4f','#a96d58','#bf7e63','#d79374','#f4a380','#2d4b47','#47655a','#5b7b69','#71957d','#87ae8e','#8ac196','#a9d1c1','#e0faeb','#001b40','#03315f','#07487c','#105da2','#1476c0','#4097ea','#55b1f1','#6dccff','#554769','#765d73','#977488','#b98c93','#d5a39a','#ebbd9d','#ffd59b','#fdf786','#1d1d21','#3c3151','#584a7f','#7964ba','#9585f1','#a996ec','#baabf7','#d1bdfe','#262450','#28335d','#2d3d72','#3d5083','#5165ae','#5274c5','#6c82c4','#8393c3','#492129','#5e414a','#77535b','#91606a','#ad7984','#b58b94','#d4aeaa','#ffe2cf','#721c03','#9c3327','#bf5a3e','#e98627','#ffb108','#ffcf05','#fff02b','#f7f4bf'];

export const GENOME_LENGTH = 32;
const ABS_STEP = 200 / 7.0;
const LINE_WIDTH = 4;
const FACE_RADIUS = 200;

const LEFT_EYE_START = 0; // 2 genes
const RIGHT_EYE_START = 2; // 2 genes
const EYES_START = 4; // 4 genes
const MOUTH_START = 8; // 4 genes
const FACE_START = 12; // 2 genes
const BACKGROUND_START = 14; // 4 genes
const DNA_LOCATION = 17; // 1 gene
const DNA_FIRST_START = 18; // 7 genes
const DNA_SECOND_START = 25; // 7 genes

const EYES_MID_POINT = EYES_START
const EYES_COLOR = EYES_START + 1
const EYE_SIZE = EYES_START + 2
const EYE_IRIS = EYES_START + 3

const newShade = (hexColor, magnitude) => {
  hexColor = hexColor.replace(`#`, ``);
  if (hexColor.length === 6) {
      const decimalColor = parseInt(hexColor, 16);
      let r = (decimalColor >> 16) + magnitude;
      r > 255 && (r = 255);
      r < 0 && (r = 0);
      let g = (decimalColor & 0x0000ff) + magnitude;
      g > 255 && (g = 255);
      g < 0 && (g = 0);
      let b = ((decimalColor >> 8) & 0x00ff) + magnitude;
      b > 255 && (b = 255);
      b < 0 && (b = 0);
      return `#${(g | (b << 8) | (r << 16)).toString(16)}`;
  } else {
      return hexColor;
  }
};

const split = (gene) =>
  [(gene >> 4), (gene & 0x0F)]; // eslint-disable-line no-bitwise

const absPosition = (gene) => {
  const splitted = split(gene);
  return [(splitted[0] - 7) * ABS_STEP, (splitted[1] - 7) * ABS_STEP];
};

const distance = (point, point2) => {
  return Math.sqrt((Math.pow(point[0]-point2[0],2))+(Math.pow(point[1]-point2[1],2)))
};


const stayInRadius = (point,radius) => {
  const rad = distance(point, [0,0])
  if (rad > radius/2) {
    return [0.95 * point[0] * radius/2.0/rad, 0.95 * point[1] * radius/2.0/rad];
  }
  return point
}

const drawFace = (draw, genes, start) => {
  var color = PALETTE[genes[start]];
  var faceSize = split(genes[start+1]);

  var color2 = newShade(color, 150);
  var gradient = draw.gradient('radial', function(add) {
    add.stop(0, color2)
    add.stop(1, color)
  });

  var circle = draw.ellipse(FACE_RADIUS+faceSize[0]*3, FACE_RADIUS+faceSize[1]*3).attr({fill: gradient, cx: 0, cy: 0 });
    circle.stroke({ width: LINE_WIDTH/2, linecap: 'round', color: "#000" });
      
  circle.filterWith(function(add) {
    var blur = add.offset(10, 10).in(add.$sourceAlpha).gaussianBlur(5)
    add.blend(add.$source, blur)
    this.size('200%','200%').move('-50%', '-50%')
  })
}

const drawEye = (draw, genes, start, xOffset) => {
  const color = PALETTE[genes[EYES_COLOR]];
  const eyemid = absPosition(genes[EYES_MID_POINT]);
  const eyesize = split(genes[EYE_SIZE]);
  const iris = genes[EYE_IRIS];
  const [eyegap, eyeup] = split(genes[start]);
  const rotate = genes[start + 1];

  var location= [0,0]
  location[0] = eyemid[0]/5 + (xOffset * ((8+eyegap)*3.5))
  location[1] = -50 + eyemid[1]/5 + eyeup

  var gradient = draw.gradient('radial', function(add) {
    add.stop(0, "#fafafa")
    add.stop(0.8, "#fafafa")
    add.stop(1, '#aaaaaa')
  });

  draw.ellipse((0.5+(eyesize[0]+1)/16.0)*60, (0.5+(eyesize[1]+1)/16.0)*70)
    .transform({ rotate: rotate/10, origin: [location[0], location[1]] })
    .attr({ fill: gradient, cx: location[0], cy: location[1] })
    .stroke({ width: LINE_WIDTH/2, linecap: 'round', color: "#000" });

  draw.circle(1+((Math.min(eyesize[1], eyesize[0])+1)/10.0) * 40).attr({ fill: color, cx: location[0], cy: location[1] });
  draw.circle(1+((Math.min(eyesize[1], eyesize[0])+1)/10.0) * (5+iris/16)).attr({ fill: "#000", cx: location[0], cy: location[1] });
}

const drawMouth = (draw, genes, start) => {
  const eyemid = absPosition(genes[EYES_MID_POINT]);
  const [mouthsize, mouthup] = split(genes[start]);
  const color = PALETTE[genes[start + 1]];
  const control_up_delta = split(genes[start + 2]);
  const control_down_delta = split(genes[start + 3]);

  var location= [0,0]
  location[0] = eyemid[0]/5
  location[1] = 20 + eyemid[1]/5 + mouthup

  var color2 = newShade(color, 50);
  var color3 = newShade(color, 100);
  var gradient = draw.gradient('radial', function(add) {
    add.stop(0, color)
    add.stop(0.9, color2)
    add.stop(1, color3)
  });

  const path = draw.path()
    .attr({
      stroke: "#000",
      fill: gradient,
      'stroke-width': LINE_WIDTH/2,
      'stroke-linejoin': 'round',
      'stroke-linecap': 'round' });

  const points = [
    stayInRadius([location[0] - (0.5+(mouthsize+1)/16.0)*50, location[1]], FACE_RADIUS),
    stayInRadius([location[0] + (0.5+(mouthsize+1)/16.0)*50, location[1]], FACE_RADIUS),
  ];
  
  const control_up_y  = (location[1] + (control_up_delta[1]*5-20));
  const control_up   = stayInRadius([(location[0] + (control_up_delta[0]-8)*5), control_up_y], FACE_RADIUS*0.8);
  const control_down = stayInRadius([control_up[0] + (control_down_delta[0]-8)*4, control_up[1] + 20 + (control_down_delta[1]*10)], FACE_RADIUS);

  const pathArray = [
    ['M', points[0][0], points[0][1]],
    ['C', control_up[0], control_up[1], control_up[0], control_up[1], points[1][0], points[1][1]],
    ['C', control_down[0], control_down[1], control_down[0], control_down[1], points[0][0], points[0][1]],
    ['Z']
  ];

  path.plot(pathArray.map((segment) => segment[0] + segment.slice(1).join(' ')).join(' '));
}

const drawBG = (draw, genes, start) => {
  var color = PALETTE[genes[start]];
  var color2 = PALETTE[genes[start+1]];
  var loc = absPosition(genes[start+2]);
  var gradient = draw.gradient('radial', function(add) {
    add.stop(0, newShade(color, 100));
    add.stop(0.5, newShade(color2, 100));
  }).from(0.5 + loc[0]/ABS_STEP/16, 0.5 + loc[1]/ABS_STEP/16).to(0.5 + loc[1]/ABS_STEP/16, 0.5 + loc[0]/ABS_STEP/16).radius(2);

  color = newShade(color, 200);
  draw.rect(360, 360).move(-180, -180).attr({ fill: gradient, cx: 0, cy: 0 });
}

const generateStrand = (svg, genes, start, direction) => {
  const points = [];

  const location = genes[DNA_LOCATION];

  if (location < 10) {
    return;
  }
  const rotate = location > 144 ? location - 200 : 0;
   
  const step = 51.5
  for (let i = 0; i <= 7; i += 1) {
    const x = -180 + i*step;
    var y = 145 + ((i%2) * direction * step/2);
    if (direction < 0) {
      y += step/2;
    }
    points.push({x,y});
  }

  var gradient = svg.gradient('linear', function(add) {
    for (let i = 0; i <= 7; i += 1) {
      const color = PALETTE[genes[start+i]];
      add.stop(i/7, color)
    }
  })

  const pathData = spline(points, 1, false);
  svg.path(pathData).attr({ fill: "none", stroke: gradient, 'stroke-width': 3, 'stroke-linecap': 'round' })
    .transform({ rotate: rotate*4, origin: [0, 0] });

}


export const drawOnchain = (draw, width, genes) => {
  const VIEWBOX = 360;
  draw.size(width, width).viewbox(-VIEWBOX/2, -VIEWBOX/2, VIEWBOX, VIEWBOX);

  drawBG(draw, genes, BACKGROUND_START);
  generateStrand(draw, genes, DNA_FIRST_START, -1);
  generateStrand(draw, genes, DNA_SECOND_START, +1);
  drawFace(draw, genes, FACE_START);
  drawMouth(draw, genes, MOUTH_START);
  drawEye(draw, genes, LEFT_EYE_START, -1);
  drawEye(draw, genes, RIGHT_EYE_START, +1);

  return draw;
}

export const stringToGenes = (genestring) => {
  const genestrings = genestring.match(/.{2}/g);
  const offset = genestrings[0] === '0x' ? 1 : 0;
  const genes = new Uint8Array(GENOME_LENGTH);
  for (let i = 0; i < GENOME_LENGTH; i += 1) {
    genes[i] = parseInt(genestrings[i + offset], 16);
  }
  return genes;
};

export const genesToString = (genes) => {
  let s = '';
  genes.forEach((g) => {
    s += `0${(Number(g).toString(16))}`.slice(-2);
  });
  return s;
};

export const randomGenes = () => {
  var genes = new Uint8Array(GENOME_LENGTH);
  for(var i=0; i < GENOME_LENGTH; i++) {
    genes[i] = Math.random() * 256;
  }
  return genes;
}

export const crossBreed = (foundation, inspiration) => {
  const genes = new Uint8Array(GENOME_LENGTH);
  for (let i = 0; i < GENOME_LENGTH; i += 1) {
    const rand = Math.random();
    if (rand < 0.99) {
      genes[i] = rand < 0.7 ? foundation[i] : inspiration[i];
      if (rand < 0.2) {
        genes[i] += (Math.random() * 16) - 8;
      }
    } else {
      genes[i] = Math.random() * 256;
    }
  }
  return genes;
}









// ********************************************************************************
// ********************************************************************************
// BELOW Spline code is from 
// https://github.com/georgedoescode/generative-utils/blob/master/src/spline.js
// ********************************************************************************
// ********************************************************************************

// MIT License

// Copyright (c) 2021 George Francis

// Permission is hereby granted, free of charge, to any person obtaining a copy
// of this software and associated documentation files (the "Software"), to deal
// in the Software without restriction, including without limitation the rights
// to use, copy, modify, merge, publish, distribute, sublicense, and/or sell
// copies of the Software, and to permit persons to whom the Software is
// furnished to do so, subject to the following conditions:

// The above copyright notice and this permission notice shall be included in all
// copies or substantial portions of the Software.

// THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND, EXPRESS OR
// IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF MERCHANTABILITY,
// FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT. IN NO EVENT SHALL THE
// AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY CLAIM, DAMAGES OR OTHER
// LIABILITY, WHETHER IN AN ACTION OF CONTRACT, TORT OR OTHERWISE, ARISING FROM,
// OUT OF OR IN CONNECTION WITH THE SOFTWARE OR THE USE OR OTHER DEALINGS IN THE
// SOFTWARE.

function formatPoints(points, close) {
  points = [...points];

  if (!Array.isArray(points[0])) {
    points = points.map(({ x, y }) => [x, y]);
  }

  if (close) {
    const lastPoint = points[points.length - 1];
    const secondToLastPoint = points[points.length - 2];

    const firstPoint = points[0];
    const secondPoint = points[1];

    points.unshift(lastPoint);
    points.unshift(secondToLastPoint);

    points.push(firstPoint);
    points.push(secondPoint);
  }

  return points.flat();
}

function spline(points = [], tension = 1, close = false, cb) {
  points = formatPoints(points, close);

  const size = points.length;
  const last = size - 4;

  const startPointX = close ? points[2] : points[0];
  const startPointY = close ? points[3] : points[1];

  let path = "M" + [startPointX, startPointY];

  cb && cb("MOVE", [startPointX, startPointY]);

  const startIteration = close ? 2 : 0;
  const maxIteration = close ? size - 4 : size - 2;
  const inc = 2;

  for (let i = startIteration; i < maxIteration; i += inc) {
    const x0 = i ? points[i - 2] : points[0];
    const y0 = i ? points[i - 1] : points[1];

    const x1 = points[i + 0];
    const y1 = points[i + 1];

    const x2 = points[i + 2];
    const y2 = points[i + 3];

    const x3 = i !== last ? points[i + 4] : x2;
    const y3 = i !== last ? points[i + 5] : y2;

    const cp1x = x1 + ((x2 - x0) / 6) * tension;
    const cp1y = y1 + ((y2 - y0) / 6) * tension;

    const cp2x = x2 - ((x3 - x1) / 6) * tension;
    const cp2y = y2 - ((y3 - y1) / 6) * tension;

    path += "C" + [cp1x, cp1y, cp2x, cp2y, x2, y2];

    cb && cb("CURVE", [cp1x, cp1y, cp2x, cp2y, x2, y2]);
  }

  return path;
}

export { spline };